// Item.tsx  (диспетчер)
import React from "react";
import { SaleItemInterface } from "../../../../common/types/types";
import { ItemVariant } from "../../../../common/types/enums";
import { ItemDetailed } from "./itemDetailed/ItemDetailed";
import { ItemMinimal } from "./itemMinimal/ItemMinimal";
import { ItemFlat } from "./itemFlat/ItemFlat";
import { ItemWide } from "./itemWide/ItemWide";

type Props = {
  item: SaleItemInterface;
  getCategoryName: (id: number) => string | undefined;
  variant?: ItemVariant;
  horizontal?: boolean;
  isAuth?: boolean;
  usingStock?: boolean;
};

export default function Item({
  item,
  getCategoryName,
  variant = ItemVariant.DETAILED,
  horizontal = false,
  isAuth,
  usingStock,
}: Props) {
  const isPrerender =
    typeof window !== "undefined" &&
    window.location.search.includes("__prerender=1");

  if (isPrerender) {
    return (
      <ItemDetailed
        item={item}
        getCategoryName={getCategoryName}
        horizontal={horizontal}
        isAuth={isAuth}
        usingStock={usingStock}
      />
    );
  }

  switch (variant) {
    case ItemVariant.MINIMAL:
      return (
        <ItemMinimal
          item={item}
          getCategoryName={getCategoryName}
          isAuth={isAuth}
          usingStock={usingStock}
        />
      );

    case ItemVariant.FLAT:
      return (
        <ItemFlat
          item={item}
          getCategoryName={getCategoryName}
          isAuth={isAuth}
          usingStock={usingStock}
        />
      );

    case ItemVariant.WIDE:
      return (
        <ItemWide
          item={item}
          getCategoryName={getCategoryName}
          isAuth={isAuth}
          usingStock={usingStock}
        />
      );

    case ItemVariant.DETAILED:
    default:
      return (
        <ItemDetailed
          item={item}
          getCategoryName={getCategoryName}
          horizontal={horizontal}
          isAuth={isAuth}
          usingStock={usingStock}
        />
      );
  }
}
